module.exports = __webpack_public_path__ + "static/media/ambulance.f72ac3c0.svg";